import AttachLibraryDialog from 'components/@home/@settings/Tabs/Agents/AttachLibraryDialog';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import { arrayOf, bool, func, object, string } from 'prop-types';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const AttachSecretsDialog = ({
  open,
  onClose,
  secrets,
  selectedNames = [],
  onSave,
  onCreate = null,
}) => {
  const namesToIds = useMemo(() => {
    const map = new Map();
    secrets.forEach(s => map.set(s.name, String(s._id)));
    return map;
  }, [secrets]);

  const idsToNames = useMemo(() => {
    const map = new Map();
    secrets.forEach(s => map.set(String(s._id), s.name));
    return map;
  }, [secrets]);

  const selectedIds = useMemo(
    () => selectedNames.map(name => namesToIds.get(name)).filter(Boolean),
    [selectedNames, namesToIds],
  );

  const handleSave = ids => {
    const nextNames = ids.map(id => idsToNames.get(String(id))).filter(Boolean);
    onSave(nextNames);
  };

  const renderMeta = secret => {
    const typeLabel = I18n.t(`AgenticChatFlow.SecretType_${secret.type}`);
    return secret.description ? `${typeLabel} \u00b7 ${secret.description}` : typeLabel;
  };

  return (
    <AttachLibraryDialog
      open={open}
      onClose={onClose}
      title={I18n.t('AgenticChatFlow.AttachSecretsTitle')}
      items={secrets}
      selectedIds={selectedIds}
      onSave={handleSave}
      onCreate={onCreate}
      createLabel={I18n.t('AgenticChatFlow.CreateSecret')}
      searchPlaceholder={I18n.t('AgenticChatFlow.SearchSecrets')}
      emptyLabel={I18n.t('AgenticChatFlow.NoSecretsLibrary')}
      noMatchesLabel={I18n.t('AgenticChatFlow.NoSecretsMatchSearch')}
      renderIcon={() => <KeyVariantIcon size={18} />}
      renderMeta={renderMeta}
    />
  );
};

AttachSecretsDialog.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  secrets: arrayOf(object).isRequired,
  selectedNames: arrayOf(string),
  onSave: func.isRequired,
  onCreate: func,
};

export default AttachSecretsDialog;
